<template>
  <div class="home">
    <div class="logobox">
      <img :src="hfliat.smallLogo" class="mminlogo" alt="" style="height:36px;"/>
      <img :src="hfliat.banner" alt="" style="max-width: 100%" class="headgbimg" />
      <img :src="hfliat.bigLogo" alt="天府软件网" class="homeimg" style="width: 450px" />
    </div>
    <!-- 副导航栏 -->
    <div class="minnav">
      <div class="mlogo">
        <img src="@/assets/images/mintflogo.png" style="height: 36px; margin: 7px 0 5px" alt="" />
      </div>
      <div class="mnav" @click="drawer = true">
        <img src="@/assets/images/list.png" style="height: 17px; margin-top: 16px; margin-right: 15px" alt="" />
      </div>
    </div>
    <!--副导航栏  -->
    <!-- 导航栏 -->
    <div class="nav" v-show="isNavShwo">
      <div class="navbox">
        <ul class="navbul">
          <li :class="{ theadbachov: $route.path === '/home' }">
            <router-link to="/home">
              <span>首&nbsp;&nbsp;&nbsp;&nbsp;页</span>
            </router-link>
          </li>
          <!-- <li v-for="(item,index) in menu_List" :key='index' @click="fn(item)" > -->
          <li v-for="(item,index) in menu_List" :key='index' @mouseover="focusMenuName(item)">
            <el-dropdown >
              <a :href="newurl(item)">
                {{item.name}}
              </a>
                <el-dropdown-menu v-if="showdropdown" slot="dropdown" style="width: 120px">
                  <a :href="newurl(item)" >
                    <el-dropdown-item   v-for="(items,indexs) in item.subCates" :key='indexs'>
                    <div >
                        <a :href="newurl(items)">
                          <span class="menuss">{{items.name}}</span>
                        </a>
                    </div>
                  </el-dropdown-item>
                  </a>

                </el-dropdown-menu>
              </el-dropdown>
          </li>

        </ul>
      </div>
    </div>
    <!--通知公告 -->
    <div class="notice">
      <div class="notbox">
        <div class="notboxl">
          <div style="float: left; margin-right: 7px">
            <span class="mt16"><img src="@/assets/images/gg.png" alt="" /></span>
            <span class="notcol">通知公告</span>
          </div>
          <div class="notcont" @click="handleSectionClick($event)">
            <vueSeamlessScroll :data="tzgglist.slice(0, 10)" :class-option="optionLeft" class="seamless-warp">
              <div class="notdo">
                <div
                  v-for="(item,index) in tzgglist.slice(0, 10)"
                  v-bind:key="index"
                  @click="handlelitxq(item.id)"
                  :title="item.title"
                  style=""
                  :data-id="item.id"
                  :data-index="index"
                >
                  {{ item.title }}
                </div>
              </div>
            </vueSeamlessScroll>
          </div>

          <span class="notcol" style="float: left" @click="fn(11)">更多</span>
        </div>
        <div class="notboxr">
          <div class="notbinp">
            <input type="text"  @keyup.enter="enterSearch" v-model="title" placeholder="请输入关键词" />
            <img
              src="@/assets/images/search.png"
              style="width: 20px; height: 20px; float: right; margin-top: 8px"
              alt=""
              @click="enterSearch"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 时政要闻 -->
    <div class="affairs">
      <div class="affbox">
        <div class="affboxl" style="max-width:600px">
            <LybSwiper :isShowdot="false" id="b" v-if="hfliat.swipeImgList_tzgg && hfliat.swipeImgList_tzgg.length">
                <div
                :isShowdot="false"
                class="swiper-slide"
                v-for="(item,index) in hfliat.swipeImgList_tzgg"
                v-bind:key="index"
              >
                <a :href="item.link">
                  <img :src="item.src" alt="" width="100px" height="100px"/>
                  <p class="swiperpt one-line" v-html="item.title"></p>
                </a>
              </div>
            </LybSwiper>
        </div>
        <div class="affboxl">
          <div class="afftitnav">
            <span @mouseenter="onMusenterone($event)" :class="{ affsp: isShow }">{{MenuName.affairs}}</span>
            <span @mouseenter="onMusentertwe($event)" :class="{ affsp: iShow }">{{MenuName.information}}</span>
            <button class="ggbtn mt3" v-show="isShow">
              <router-link to="szyw?id=8">更多</router-link>
            </button>
            <button class="ggbtn mt3" v-show="iShow">
              <router-link to="hyez?id=9">更多</router-link>
            </button>
          </div>
          <div class="afflist" v-show="isShow">
            <ul>
              <router-link class="routerbox" :to="'/show?id=' + item.id" v-for="(item,index) in afflist.slice(0, 6)" v-bind:key="index">
                <div class="afftime">
                  <div>{{ item.dd }}</div>
                  <div>{{ item.createTime }}</div>
                </div>
                <div class="affcont one-line" :class="{isTop:item.istop == 1}">{{item.title}}</div>
              </router-link>
            </ul>
          </div>
          <div class="afflist" v-show="iShow">
            <ul>
              <router-link class="routerbox" :to="'/show?id=' + item.id" v-for="(item,index) in hhylist.slice(0, 6)" v-bind:key="index">
                <div class="afftime">
                  <div>{{ item.dd }}</div>
                  <div>{{ item.createTime }}</div>
                </div>
                <div class="affcont one-line" :class="{isTop:item.istop == 1}" v-html="item.title"></div>
              </router-link>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 赢在成都 -->
    <div class="wicd">
      <div class="wicdbox">
        <div class="winbl">
          <div class="winitit">丨赢在成都</div>
          <div class="winicont" v-show="iscdgk">
            <img :src="hfliat.content_img_1" alt="" />
          </div>
          <div class="winicont" v-show="isfzhj">
            <img :src="hfliat.content_img_2" alt="" />
          </div>
          <div class="winicont" v-show="iscycj">
            <img :src="hfliat.content_img_3" alt="" />
          </div>
        </div>
        <div class="winbr">
          <div class="winbrcont">
            <div class="winbllist">
              <ul>
                <li :class="{ onck: iscdgk }" @mouseenter="oncdgk($event)">成都概况</li>
                <li :class="{ onck: isfzhj }" @mouseenter="onfzhj($event)">发展环境</li>
                <li :class="{ onck: iscycj }" @mouseenter="oncycj($event)">产业成就</li>
              </ul>
            </div>
            <div class="winbllcont ent-line" v-show="iscdgk">
              <span>
                {{wicdlist.survey_content | ellipsis6}}
                <router-link to="/cdgk" v-show="iscdgk" class="routerbox1">查看更多</router-link>
                <!-- <button class="winbrbtn" @click="rotegk" v-show="iscdgk">查看更多</button> -->
              </span>
            </div>
            <div class="winbllcont ent-line" v-show="isfzhj">
                <span>
                  {{wicdlist.environment_content | ellipsis6}}
                  <router-link to="/fzhj" v-show="isfzhj" class="routerbox1">查看更多</router-link>
                  <!-- <button class="winbrbtn" @click="rotehj" v-show="isfzhj">查看更多</button> -->
                </span>
            </div>
            <div class="winbllcont ent-line" v-show="iscycj">
                <span>
                  {{wicdlist.develop_content | ellipsis6}}
                  <router-link to="/cycj" v-show="iscycj" class="routerbox1">查看更多</router-link>
                  <!-- <button class="winbrbtn" @click="rotecj" v-show="iscycj">查看更多</button> -->
                </span>
            </div>
          </div>
          <div class="cdggbtn">
            <div class="cdggcont">
              <img src="@/assets/images/cdgk.png" @click="rotegk" alt="" />
              <img src="@/assets/images/fzhj.png" @click="rotehj" alt="" />
              <img src="@/assets/images/cycj.png" @click="rotecj" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 专题活动 -->
    <div class="aactive">
      <div class="actbox">
        <div class="winitit diswb">丨{{MenuName.Special}}</div>
        <div class="actcont">
          <div class="actcl">
            <div class="actit1">
              <span>建圈强链</span>
              <button class="ggbtn">
                <router-link to="jqql?id=110">更多</router-link>
              </button>
            </div>
            <swipertwo></swipertwo>
          </div>
          <div class="actimg">
            <div class="actit1" style="margin-right:0px;margin-left:0px;">
              <span>{{MenuName.twenty}}</span>
              <button class="ggbtn">
                <router-link to="qlhd?id=111">更多</router-link>
              </button>
            </div>
            <div class="actimgbox">
              <router-link class="routerbox" :to="'/show?id=' + item.id" v-for="(item,index) in xlhdlist.slice(0, 2)" v-bind:key="index" style="display: flex; justify-content: center; width: 100%">
                <!-- <img
                  :src="item.files.length ? item.files[0].src : require('../assets/images/mrone.png')"
                  :alt="item.title"
                  :title="item.title"
                  style="width: 100%"
                /> -->
                <img
                    :src="twtyfmimg[index] == '' ? require('../assets/images/mrone.png') : twtyfmimg[index]"
                    :alt="item.title"
                    :title="item.title"
                    style="width: 100%"
                    alt=""
                  />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 软件名城 -->
    <div class="sofcity">
      <div class="sofcbox">
        <div class="sofl">
          <div class="winitit mb2">丨{{MenuName.softCity}}</div>
          <div class="soflbox dflex">
            <div>

              <div class="sbox1" >
                <router-link :to='softUrl' target='_blank'>
                <div class="transf" @mouseenter="mouqydt('企业动态')">
                  <img src="@/assets/images/Slice1.png" alt="" />
                  <p>企业动态</p>
                </div>
                </router-link>
              </div>
              <div class="sbox2" >
                <router-link :to='softUrl' target='_blank'>
                <div class="transf" @mouseenter="mouqydt('园区动态')">
                  <img src="@/assets/images/Slice2.png" alt="" />
                  <p>园区动态</p>
                </div>
                </router-link>
              </div>
            </div>
            <div>
              <div class="sbox3" >
                <router-link :to='softUrl' target='_blank'>
                <div class="transf" @mouseenter="mouqydt('产品服务')">
                  <img src="@/assets/images/Slice3.png" alt="" />
                  <p>产品服务</p>
                </div>
                </router-link>
              </div>
              <div class="sbox4" >
                <router-link :to='softUrl' target='_blank'>
                <div class="transf" @mouseenter="mouqydt('公共平台')">
                  <img src="@/assets/images/Slice4.png" alt="" />
                  <p>公共平台</p>
                </div>
                </router-link>
              </div>
              <div class="sbox5" >
                <router-link :to='softUrl' target='_blank'>
                <div class="transf" @mouseenter="mouqydt('人才建设')">
                  <img src="@/assets/images/Slice5.png" alt="" />
                  <p>人才建设</p>
                </div>
                </router-link>
              </div>
            </div>
            <div>
              <div class="sbox6" >
                <router-link :to='softUrl' target='_blank'>
                <div class="transf" @mouseenter="mouqydt('人物榜样')">
                  <img src="@/assets/images/Slice6.png" alt="" />
                  <p>人物榜样</p>
                </div>
                </router-link>
              </div>
              <div class="sbox7" >
                <router-link :to='softUrl' target='_blank'>
                <div class="transf" @mouseenter="mouqydt('万众创新')">
                  <img src="@/assets/images/Slice7.png" alt="" />
                  <p>万众创新</p>
                </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="sofr">
          <div class="actit mb2 bt15 rcjscsss" v-show="item.isshow" v-for="(item,index) in softList" :key="index">
            <span>{{item.name}}</span>
            <button class="ggbtn"><router-link :to='softUrl' target='_blank'>更多</router-link></button>
          </div>
          <div class="sofrbox" style="margin-top:23px;" v-show="item.isshow" v-for="(item,index) in softList" :key="index">
              <ul>
                <router-link :to="'/show?id=' + item.id" class="routerbox" style="display: flex" v-for="(item,index) in soflist.slice(0, 3)" v-bind:key="index">
                  <!-- <img
                    :src="item.files.length ? item.files[0].src : require('../assets/images/39.png')"
                    class="sofrimg"
                    alt=""
                  /> -->
                  <div style="width:164px;height:134px;display:inline-block">
                    <img
                    :src="rjmcfmimg[index] == '' ? require('../assets/images/39.png') : rjmcfmimg[index]"
                    class="sofrimg"
                    alt=""
                  />
                  </div>

                  <div class="sofrcont">
                    <h3 class="two-line">{{ item.title | ellipsis4 }}</h3>
                    <p class="two-line">{{ item.content | ellipsis3 }}</p>
                    <button id="sofact">查看详情</button>
                  </div>
                </router-link>
              </ul>
            </div>
        </div>
      </div>
    </div>
    <!-- 产业政策 -->
    <div class="policy">
      <div class="polbox">
        <div class="winitit mb2">丨{{MenuName.industrial}}</div>
        <div class="indcont">
          <div class="polibox1">
            <div class="icontcol">
              <div class="actit mb2">
                <span>国家</span>
                 <button class="ggbtn" v-show="isShow">
                                <router-link to="gjj?id=2000">更多</router-link>            
                </button>
              </div>
              <div class="indlist4">
                <ul>
                  <li
                    v-for="(itemgg,index) in gjjlist.slice(0, 10)"
                    v-bind:key="index"
                    :title="itemgg.title"
                  >
                  <router-link :to="'/show?id=' + itemgg.id" class="routerbox">
                    <img src="../assets/images/tfzd.png" style="width:10px; height:10px;float:left;margin-top: 5px;" v-if="itemgg.istop"  alt="">
                    <div>[{{ itemgg.createTime }}]</div>
                    <div v-html="itemgg.title" class="gjjlist isTop one-line" v-if="itemgg.istop"></div>
                    <div v-html="itemgg.title" class="gjjlist one-line" v-else></div>
                  </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="polibox2">
            <div class="icontcol">
              <div class="actit mb2">
                <span>四川</span>
                 <button class="ggbtn" v-show="isShow">
                                <router-link to="scj?id=2001">更多</router-link>            
                </button>
              </div>
              <div class="indlist4">
                <ul>
                  <li
                    v-for="(itemsc,index) in scjlist.slice(0, 10)"
                    v-bind:key="index"
                    @click="handlelitxq(itemsc.id)"
                    :title="itemsc.title"
                  >
                  <router-link :to="'/show?id=' + itemsc.id" class="routerbox">
                    <img src="../assets/images/tfzd.png" style="width:10px; height10px;float:left;margin-top: 5px;" v-if="itemsc.istop"  alt="">
                    <div>[{{ itemsc.createTime }}]</div>
                    <div v-html="itemsc.title" class="gjjlist one-line" v-if="itemsc.istop"></div>
                    <div v-html="itemsc.title" class="gjjlist one-line" v-else></div>
                  </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="polibox3">
            <div class="actit mb2">
              <span>成都</span>
              <button class="ggbtn" v-show="isShow">
                              <router-link to="cdj?id=2002">更多</router-link>            
              </button>
            </div>
            <div class="irolist1" style="margin-top:23px">
              <ul>
                <li
                  class="irolbox1"
                  v-for="(itemcd,index) in cdjlist.slice(0, 3)"
                  v-bind:key="index"
                >
                  <router-link :to="'/show?id=' + itemcd.id" class="routerbox" style="display:flex;width:100%">
                  <div class="icolimg1">
                    <!-- <img   :src="itemcd.files.length ? itemcd.files[0].src : require('../assets/images/39.png')" style="max-width: 112px; height: 87px" alt="" /> -->
                    <div style="max-width: 112px; height: 87px">
                      <img
                        :src="cdfmimg[index] == '' ? require('@/assets/images/39.png') : cdfmimg[index]"
                        style="width:100%;height:100%"
                        alt=""
                      />
                    </div>

                  </div>
                  <div class="iconcont1">
                    <div class="polsp1 three-line" :title="itemcd.title" v-html="itemcd.title"></div>
                    <div class="polsp2">
                      <img src="@/assets/images/cdsj.png" style="width: 14px; height: 14px; margin-top: -5px" alt="" />

                      {{ time(itemcd.createTime, "YYYY-MM-DD") }}
                      <img src="@/assets/images/cdyj.png" style="margin: -5px 5px 0 15px" alt="" />{{ itemcd.pv }}次
                    </div>
                    <div class="polsp3 three-line" v-html="itemcd.content" ></div>
                  </div>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 产业服务 -->
    <div class="services">
      <div class="serbox">
        <div class="winitit mb2">丨产业服务</div>
        <div class="serboxcont">
          <swiperthree></swiperthree>
        </div>
      </div>
    </div>
    <!--footer -->
    <div class="finp">
      <div class="finpbox">
        <ul>
          <li>友情链接</li>
          <li>
            <div class="selectbox" v-if="hfliat.friendshipLink" v-html="hfliat.friendshipLink[0]">
            </div>
          </li>
          <li>
            <div class="selectbox" v-if="hfliat.friendshipLink" v-html="hfliat.friendshipLink[1]">
            </div>
          </li>
          <li>
            <div class="selectbox" v-if="hfliat.friendshipLink" v-html="hfliat.friendshipLink[2]">
            </div>
          </li>
          <li>
            <div class="selectbox" v-if="hfliat.friendshipLink" v-html="hfliat.friendshipLink[3]">
            </div>
          </li>
          <li>
            <div class="selectbox" v-if="hfliat.friendshipLink" v-html="hfliat.friendshipLink[4]">
            </div>
          </li>
        </ul>
      </div>
    </div>
    <footbox></footbox>
  </div>
</template>

<script>
import headbox from "../components/head.vue";
import moment from "moment/moment";
import footbox from "@/components/footer.vue";
import Swiper from "@/swiper/swiper-bundle.min.js";
// import swiperone from "@/components/swiper/swiperOne.vue";
import swipertwo from "@/components/swiper/swiperTwo.vue";
import swiperthree from "@/components/swiper/swiperthree.vue";
import { news, detail,MenuList,getNames } from "@/api/index.js";
import { $fmtTime } from "@/utils/utils.js";
import vueSeamlessScroll from "vue-seamless-scroll";
import LybSwiper from '@/components/lyb-swipe';
export default {
  filters: {
    ellipsis(value) {
      // 正则去除html标签
      value = value.replace(/<[^>]+>/g, "");
      // 判断是否为空
      if (!value) return "";
      // 不为空将显示字数小于90个
      if (value.length > 45) {
        return value.slice(0, 45) + "...";
      }
      return value;
    },
    ellipsis1(value) {
      // 正则去除html标签
      value = value.replace(/<[^>]+>/g, "");
      // 判断是否为空
      if (!value) return "";
      // 不为空将显示字数小于90个
      if (value.length > 200) {
        return value.slice(0, 200) + "...";
      }
      return value;
    },
    ellipsis2(value) {
      // 正则去除html标签
      value = value.replace(/<[^>]+>/g, "");
      // 判断是否为空
      if (!value) return "";
      // 不为空将显示字数小于90个
      if (value.length > 18) {
        return value.slice(0, 18) + "...";
      }
      return value;
    },
    ellipsis3(value) {
      // 正则去除html标签
      if (value.match(/[\u4e00-\u9fa5]/g)) {
        value = value.match(/[\u4e00-\u9fa5]/g).join('');
      } else {
        return;
      }
      // 不为空将显示字数小于90个
      if (value.length > 100) {
        return value.slice(0, 100) + '...';
      }
      return value;
    },
    ellipsis4(value) {
      // 正则去除html标签
      value = value.replace(/<[^>]+>/g, "");
      // 判断是否为空
      if (!value) return "";
      // 不为空将显示字数小于90个
      if (value.length > 35) {
        return value.slice(0, 35) + "...";
      }
      return value;
    },
    ellipsis5(value) {
      // 正则去除html标签
      value = value.replace(/<[^>]+>/g, "");
      // 判断是否为空
      if (!value) return "";
      // 不为空将显示字数小于90个
      if (value.length > 69) {
        return value.slice(0, 69) + "...";
      }
      return value;
    },
    ellipsis6(value) {
      // 正则去除html标签
      value = value.replace(/<[^>]+>/g, "");
      // 判断是否为空
      if (!value) return "";
      // 不为空将显示字数小于90个
      if (value.length > 303) {
        return value.slice(0, 303) + "...";
      }
      return value;
    },
  },
  name: "home",
  data() {
    return {
      isShow: true,
      iShow: false,
      isReactive: 0,
      isNavShwo: true,
      issofs: true,
      issof: false,
      title: "",
      iscdgk: true,
      isfzhj: false,
      iscycj: false,

      ismou: true,
      isyqdt: false,
      iscpfw: false,
      isggpt: false,
      isrcjs: false,
      isrwby: false,
      iswzcx: false,

      // 时政要闻
      afflist: [],
      // 行业资讯
      hhylist: [],
      // 赢在成都
      wicdlist: [],
      // 发展环境
      fzhjlist: [],
      // 产业成就
      cycjlist: [],
      // 专题活动
      actlist: [],
      // 软件名城
      soflist: [],
      // 通知公告
      tzgglist:[],
      yqdt: [],
      cpfw: [],
      ggpt: [],
      rcjs: [],
      rwby: [],
      wzcx: [],
      // 国家级
      gjjlist: [],
      // 四川级
      scjlist: [],
      // 成都级
      cdjlist: [],
      hfliat: [],
      // 20+系列活动
      xlhdlist: [],
      drawer: false,
      menu_List:'',
      showdropdown:false,
      MenuName:{
        affairs:'',//时政要闻
        information:'',//行业资讯
        CD:'',//赢在成都
        Special:'',//专题活动
        softCity:'',//软件名城
        industrial:'',//产业政策
        services:'',//产业服务
        twenty:"",//20+
      },
      softList:'',
      softUrl:'',
      twtyfmimg:[],
      rjmcfmimg:[],
      cdfmimg:[],
    };
  },
  computed: {
    time() {
      return $fmtTime;
    },
    optionLeft() {
      return {
        direction: 2,
        limitMoveNum: 5,
        waitTime: 50, //滚动的速度
      };
    },
  },
  components: {
    // swiperone,
    swipertwo,
    swiperthree,
    footbox,
    vueSeamlessScroll,
    headbox,
    LybSwiper
  },
  created() {
    this.getMenuList()
    // 时政要闻
    this.handleafflist();
    // 行业资讯
    this.handlehhylist();
    // 赢在成都
    this.handlewicdlist();
    this.handlefzhjlist();
    this.handlecycjlist();
    // 专题活动
    this.handleactlist();
    // 软件名城
    this.handlesoflist();
    // 国家级
    this.handlggjllist();
    //  四川级
    this.handlescjlist();
    //  成都级
    this.handlecdjlist();
    this.handleheadfoot();
    // 系列活动
    this.handlexlhdlist();
    // 通知公告
    this.handletzgglist();
  },
  methods: {
    getMenuList() {
      MenuList({siteId:5}).then(res => {
        let menu_List = res.data.data
        this.menu_List = menu_List.map(item => {
          if(item.subCates.length == 0) {
            // Reflect.deleteProperty(item,"subCates");
            // document.querySelector('.el-popper').style.display = 'none'
          }
          return item
        })
        let softList = this.menu_List.filter((item,index) => {
          return item.id == '14'
        })
        this.softList = softList[0].subCates.map((item,index) => {
          return {...item,isshow:0}
        })
        this.softList[0].isshow = 1
      })
    },
    focusMenuName(e) {
      if(e.subCates.length !== 0) {
        this.showdropdown = true
      }else {
        this.showdropdown = false
      }
    },
    handlelitxq(id) {
     let goUrl = this.$router.resolve({ path: "show", query: { id: id } });
     window.open(goUrl.href,'_blank')
    },
    rotegk() {
      let goUrl = this.$router.resolve({ path: "cdgk" });
     window.open(goUrl.href,'_blank')
    },
    rotehj() {
      let goUrl = this.$router.resolve({ path: "fzhj" });
     window.open(goUrl.href,'_blank')
    },
    rotecj() {
      let goUrl = this.$router.resolve({ path: "cycj" });
     window.open(goUrl.href,'_blank')
    },
    onMusenterone($event) {
      this.isShow = true;
      this.iShow = false;
    },
    onMusentertwe($event) {
      this.isShow = false;
      this.iShow = true;
    },
    oncdgk($event) {
      this.iscdgk = true;
      this.isfzhj = false;
      this.iscycj = false;
    },
    onfzhj($event) {
      this.iscdgk = false;
      this.isfzhj = true;
      this.iscycj = false;
    },
    oncycj($event) {
      this.iscdgk = false;
      this.isfzhj = false;
      this.iscycj = true;
    },
    mouqydt(e) {
      for(let i in this.softList) {
        if(this.softList[i].name == e) {
          this.softList[i].isshow = 1
          this.softUrl = `details?id=${this.softList[i].id}`
          news({ siteId: 5, cate_id:this.softList[i].id , online: 1 }).then((res) => {
            this.soflist = res.data.data.records;
            this.soflist.forEach((item) => {
              item.files = JSON.parse(item.files);
            });
            this.rjmcfmimg = []
            this.soflist.map((item,index) => {
              //存的是fujian&fmimg还是filename
              if(item.files.fmimg == undefined) {
                //存的是filename
                if( item.files.length == 0) {
                    //没有上传图片
                    this.rjmcfmimg[index] = ""
                }else {
                  //上传了图片
                  item.files.map(items => {
                    if(["png","jpg","jpeg"].indexOf(items.src.slice(-3)) != -1) {
                      this.rjmcfmimg.push(items.src)
                    }
                    else {
                      this.rjmcfmimg[index] = ""
                    }
                  })
                }
              }
              else if( item.files.fmimg.length == 0) {
                  this.rjmcfmimg[index] = ""
              }
              else {
                this.rjmcfmimg.push(item.files.fmimg[0].src)
              }
            })
          });
        }else {
          this.softList[i].isshow = 0
        }
      }

    },
    mouyqdt($event) {
      this.ismou = false;
      this.isyqdt = true;
      this.iscpfw = false;
      this.isggpt = false;
      this.isrcjs = false;
      this.isrwby = false;
      this.iswzcx = false;
    },
    moucpfw($event) {
      this.ismou = false;
      this.isyqdt = false;
      this.iscpfw = true;
      this.isggpt = false;
      this.isrcjs = false;
      this.isrwby = false;
      this.iswzcx = false;
    },
    mouggpt($event) {
      this.ismou = false;
      this.isyqdt = false;
      this.iscpfw = false;
      this.isggpt = true;
      this.isrcjs = false;
      this.isrwby = false;
      this.iswzcx = false;
    },
    mourcjs($event) {
      this.ismou = false;
      this.isyqdt = false;
      this.iscpfw = false;
      this.isggpt = false;
      this.isrcjs = true;
      this.isrwby = false;
      this.iswzcx = false;
    },
    mourwby($event) {
      this.ismou = false;
      this.isyqdt = false;
      this.iscpfw = false;
      this.isggpt = false;
      this.isrcjs = false;
      this.isrwby = true;
      this.iswzcx = false;
    },
    mouwzcx($event) {
      this.ismou = false;
      this.isyqdt = false;
      this.iscpfw = false;
      this.isggpt = false;
      this.isrcjs = false;
      this.isrwby = false;
      this.iswzcx = true;
    },

    // 获取时政要闻数据
    handleafflist() {
      news({ siteId: 5, cate_id: 8, online: 1 }).then((res) => {
        this.afflist = res.data.data.records;
        this.afflist.forEach((item) => {
          item.dd = moment(item.createTime).format("DD");
          item.createTime = moment(item.createTime).format("YYYY-MM");
        });
      });
      getNames(8).then(res => {
         this.MenuName.affairs = res.data.data.name
      })
    },
      // 获取通知公告数据
    handletzgglist() {
      news({ siteId: 5, cate_id: 11, online: 1 }).then((res) => {
        this.tzgglist = res.data.data.records;
      });
    },

    // 获取行业资讯数据
    handlehhylist() {
      news({ siteId: 5, cate_id: 9 ,online: 1 }).then((res) => {
        this.hhylist = res.data.data.records;
        this.hhylist.forEach((item) => {
          item.dd = moment(item.createTime).format("DD");
          item.createTime = moment(item.createTime).format("YYYY-MM");
          //
        });
        //

      });
      getNames(9).then(res => {
         this.MenuName.information = res.data.data.name
      })
    },
    // 获取成都概况数据
    handlewicdlist() {
      detail(5).then((res) => {
        this.wicdlist = JSON.parse(res.data.data.config);
        //
      });
    },
    // 获取发展环境数据
    handlefzhjlist() {
      detail(5).then((res) => {
        this.fzhjlist = JSON.parse(res.data.data.config);
        //
      });
    },
    // 获取产业成就数据
    handlecycjlist() {
      detail(5).then((res) => {
        this.cycjlist = JSON.parse(res.data.data.config);
      });

    },
    // 获取专题活动数据
    handleactlist() {
      news({ siteId: 5, cate_id: 10, online: 1 }).then((res) => {
        this.actlist = res.data.data.records;
      });
      getNames(10).then(res => {
         this.MenuName.Special = res.data.data.name
      })
    },
    // 获取软件名城数据
    handlesoflist() {
      news({ siteId: 5, cate_id: 13, online: 1 }).then((res) => {
        this.soflist = res.data.data.records;
        this.soflist.forEach((item) => {
          item.files = JSON.parse(item.files);
        });
        this.rjmcfmimg = []
            this.soflist.map((item,index) => {
              //存的是fujian&fmimg还是filename
              if(item.files.fmimg == undefined) {
                //存的是filename
                if( item.files.length == 0) {
                    //没有上传图片
                    this.rjmcfmimg[index] = ""
                }else {
                  //上传了图片
                  item.files.map(items => {
                    if(this.getFileType(items.src) == 'image') {
                      this.rjmcfmimg.push(items.src)
                    }
                    else {
                      this.rjmcfmimg[index] = ""
                    }
                  })
                }
              }
              else if( item.files.fmimg.length == 0) {
                  this.rjmcfmimg[index] = ""
              }
              else {
                this.rjmcfmimg.push(item.files.fmimg[0].src)
              }
            })

      });
      news({ siteId: 5, cate_id: 120, online: 1 }).then((res) => {
        this.yqdt = res.data.data.records;
        this.yqdt.forEach((item) => {
          item.files = JSON.parse(item.files);
        });
      });
      news({ siteId: 5, cate_id: 121, online: 1 }).then((res) => {
        this.cpfw = res.data.data.records;
        this.cpfw.forEach((item) => {
          item.files = JSON.parse(item.files);
        });
      });
      news({ siteId: 5, cate_id: 122, online: 1 }).then((res) => {
        this.ggpt = res.data.data.records;
        this.ggpt.forEach((item) => {
          item.files = JSON.parse(item.files);
        });
      });
      news({ siteId: 5, cate_id: 123, online: 1 }).then((res) => {
        this.rcjs = res.data.data.records;
        this.rcjs.forEach((item) => {
          item.files = JSON.parse(item.files);
        });
      });
      news({ siteId: 5, cate_id: 124, online: 1 }).then((res) => {
        this.rwby = res.data.data.records;
        this.rwby.forEach((item) => {
          item.files = JSON.parse(item.files);
        });
      });
      news({ siteId: 5, cate_id: 125, online: 1 }).then((res) => {
        this.wzcx = res.data.data.records;
        this.wzcx.forEach((item) => {
          item.files = JSON.parse(item.files);
        });
      });
      getNames(13).then(res => {
         this.MenuName.softCity = res.data.data.name
      })
    },
    // 获取产业政策数据
    handlggjllist() {
      news({ siteId: 5, cate_id: 2000, online: 1 }).then((res) => {
        this.gjjlist = res.data.data.records;
        this.gjjlist.forEach((item) => {
          item.createTime = moment(item.createTime).format("MM.DD");
        });
        //
      });
      getNames(12).then(res => {
         this.MenuName.industrial = res.data.data.name
      })
    },
    // 获取产业政策数据
    handlescjlist() {
      news({ siteId: 5, cate_id: 2001, online: 1 }).then((res) => {
        this.scjlist = res.data.data.records;
        this.scjlist.forEach((item) => {
          item.createTime = moment(item.createTime).format("MM.DD");
        });
        //
        // this.MenuName.information = this.afflist[0].cateName
      });
    },
    // 获取产业政策数据
    handlecdjlist() {
      news({ siteId: 5, cate_id: 2002, online: 1 }).then((res) => {
        this.cdjlist = res.data.data.records;
        this.cdjlist.forEach((item) => {
          item.files = JSON.parse(item.files);
        });
        // this.cdfmimg = []
            this.cdjlist.map((item,index) => {
              //存的是fujian&fmimg还是filename
              if(item.files.fmimg == undefined) {
                //存的是filename
                if( item.files.length == 0) {
                    //没有上传图片
                    this.cdfmimg[index] = ""
                }else {
                  //上传了图片
                  item.files.map(items => {
                    if(this.getFileType(items.src) == 'image') {
                      this.cdfmimg.push(items.src)
                    }
                    else {
                      this.cdfmimg[index] = ""
                    }
                  })
                }
              }
              else if( item.files.fmimg.length == 0) {
                  this.cdfmimg[index] = ""
              }
              else {
                this.cdfmimg.push(item.files.fmimg[0].src)
              }
            })

      });
    },
    // 获取20系列活动数据
    handlexlhdlist() {
      news({ siteId: 5, cate_id: 111, limit: 2, online: 1 }).then((res) => {
        this.xlhdlist = res.data.data.records;
        this.xlhdlist.forEach((item) => {
          item.files = JSON.parse(item.files);
        });
        this.xlhdlist.map((item,index) => {
          if( item.files.length == 0) {
              this.twtyfmimg[index] = ""
          }else {
            if(item.files.fmimg == undefined) {
              item.files.map(items => {
                if(this.getFileType(items.src) == 'image') {
                  this.twtyfmimg.push(items.src)
                }
                else {
                  this.twtyfmimg.push('')
                }
              })
            }
            else {
              if(item.files.fmimg.length == 0) {
                  this.twtyfmimg.push('')
              }else {
                this.twtyfmimg.push(item.files.fmimg[0].src)
              }
            }
          }
        })
      });
      getNames(111).then(res => {
         this.MenuName.twenty = res.data.data.name
      })
    },
    //导航栏的显示与隐藏
    shownav() {
      this.isNavShwo = !this.isNavShwo;
    },
    newurl(e) {
      let id = e.id
      const obj = {
        100: "/cdgk",
        101: "fzhj",
        102: "cycj"
      };
      if(e.id == 100 || e.id == 101 || e.id == 102) {
        return obj[e.id] + '?id=' + e.id
      }
      if(e.subCates != undefined) {
        if(e.subCates.length == 0) {
          return '/#/details?id=' + e.id
        }else {
          return
        }
      }
      else {
        return '/#/details?id=' + e.id
      }
    },
    fn(e) {
      let id = e.id
      const obj = {
        100: "/cdgk",
        101: "fzhj",
        102: "cycj"
      };
      if(e.id == 100 || e.id == 101 || e.id == 102) {
        let goUrl = this.$router.resolve({path:obj[e.id],query: {id:id}})
        window.open(goUrl.href,'_blank')
      }else {
        if(e == 11) {
          let goUrl = this.$router.resolve({path:'/details',query: {id:e}})
          window.open(goUrl.href,'_blank')
        }else if(e.subCates == undefined || e.subCates.length == 0 ) {
          // 一级菜单直接跳转页面
          let goUrl = this.$router.resolve({path:'/details',query: {id:id}})
          window.open(goUrl.href,'_blank')
        }
      }
    },
    // 回车搜索
    enterSearch() {
       if(this.title == ""){
          this.$message({
            message: '请输入内容',
            type: 'warning'
          });
        }else{
          this.$router.push({ path: "/search", query: { title: this.title } });
        }
    },

    //头部底部数据
    handleheadfoot() {
      detail(5).then((res) => {
        this.hfliat = JSON.parse(res.data.data.config);
      });
    },

    // 给vue-seamless-scroll第二组添加点击事件
    handleSectionClick(e) {
      let ttarget = e.target;
      const _this = this
      if (ttarget.tagName === 'DIV') {
        ttarget.onclick = function () {
          let id = ttarget.dataset.id;
           _this.$router.push({ path: "/show", query: { id: id } });
        };
      }
    },
      handleheft(){
       this.$router.push({ path: "/home"});
    },
    /* 根据后缀判断文件类型 */
    getFileType(fileName) {
      let suffix = ''; // 后缀获取
      let result = ''; // 获取类型结果
      if (fileName) {
        const flieArr = fileName.split('.'); // 根据.分割数组
        suffix = flieArr[flieArr.length - 1]; // 取最后一个
      }
      if (!suffix) return false; // fileName无后缀返回false
      suffix = suffix.toLocaleLowerCase(); // 将后缀所有字母改为小写方便操作
      // 匹配图片
      const imgList = ['png', 'jpg', 'jpeg', 'bmp',"JPG","PNG","JPEG","BMP"]; // 图片格式
      result = imgList.find(item => item === suffix);
      if (result) return 'image';
      // 匹配txt
      const txtList = ['txt'];
      result = txtList.find(item => item === suffix);
      if (result) return 'txt';
      // 匹配excel
      const excelList = ['xls', 'xlsx'];
      result = excelList.find(item => item === suffix);
      if (result) return 'excel';
      // 匹配word
      const wordList = ['doc', 'docx'];
      result = wordList.find(item => item === suffix);
      if (result) return 'word';
      // 匹配pdf
      const pdfList = ['pdf'];
      result = pdfList.find(item => item === suffix);
      if (result) return 'pdf';
      // 匹配ppt
      const pptList = ['ppt', 'pptx'];
      result = pptList.find(item => item === suffix);
      if (result) return 'ppt';
      // 匹配zip
      const zipList = ['rar', 'zip', '7z'];
      result = zipList.find(item => item === suffix);
      if (result) return 'zip';
      // 匹配视频
      const videoList = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v'];
      result = videoList.find(item => item === suffix);
      if (result) return 'video';
      // 匹配音频
      const radioList = ['mp3', 'wav', 'wmv'];
      result = radioList.find(item => item === suffix);
      if (result) return 'radio';
      // 其他文件类型
      return 'other';
    },
  },
};
</script>
<style lang="less">
// .swiper-container {
//   max-width: 100%;
//   height: 500px;
// }
.finp {
  background: #2ea8e1;
  height: 40px;
  line-height: 40px;
  @media screen and (max-width: 1050px) {
    display: none;
  }
}
.finpbox {
  width: 1050px;
  margin: 0 auto;
  color: #fff;
  text-align: center;
}
.finpbox > ul {
  display: flex;
}
.finpbox > ul > li {
  flex: 1;
  margin: 0 15px;
  font-size: 16px;
  color: #fff;
}
.selectbox {
  width: 117px;
  color: #7a7a7a;
  height: 25px;
  line-height: 21px;
  margin-top: 9px;
  border-radius: 5px;
  border: 0;
  border: 1px solid #fff;
  background: #fff;
}
.selectbox > select {
  width: 114px;
  color: #7a7a7a;
  border-radius: 5px;
  border: 1px solid #fff;
  outline: none;
}
.logobox {
  max-width: 1600px;
  margin: 0 auto;
  position: relative;
  @media screen and (max-width: 900px) {
    display: none;
  }
}
.homeimg {
  max-width: 547px;
  position: absolute;
  top: 126px;
  left: 219px;
  @media screen and (max-width: 1150px) {
    top: 70px;
  }
  @media screen and (max-width: 1100px) {
    display: none;
  }
}
.mminlogo {
  position: absolute;
  top: 15px;
  left: 15px;
}
.nav {
  background: #0086e3;
  color: #fff;
  position: sticky;
  top: 0;
  z-index: 999;
}
.navbul {
  display: flex;
  max-width: 1200px;
  font-size: 16px;
  margin: 0 auto;
  & > li {
    flex: 1;
    // border-right: 1px solid #fff;
    cursor: pointer;
    height: 65px;
    line-height: 65px;
    position: relative;
  }
  & > li:first-child::before {
    content: "";
    left: 0;
    top: 18px;
    display: block;
    background: #fff;
    position: absolute;
    width: 1px;
    height: 30px;
  }
  & > li:after {
    content: "";
    right: 0;
    top: 18px;
    display: block;
    background: #fff;
    position: absolute;
    width: 1px;
    height: 30px;
  }
  & > li > a {
    display: block;
  }
  & > li:hover {
    background: #ff9900;
  }
}
.theadbachov{
  background: #ff9900;
}
.minnav {
  background: #fff;
  display: flex;
  display: none;

  justify-content: space-between;
}
.notice {
  background: #f8f7ea;
  @media screen and (max-width: 915px) {
    display: none;
  }
}
.notbox {
  max-width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  height: 56px;
  line-height: 56px;
}
.notboxl {
  float: left;
  font-size: 16px;
  color: #7a7a7a;
}
.notcol {
  color: #ff9900;
  cursor: pointer;
  font-size:14px;
}
.notcol:first-child {
  margin-right: 15px;
}
.notcont {
  float: left;
  width: 820px;
  overflow: hidden;
  position: relative;
  margin-right: 5px;
}
// .notcont > div {
//   // width: 100%;
//   // animation: wordsLoop 10s linear infinite normal;
// }
.notdt {
  position: absolute;
  left: 560px;
  top: 0px;
  width: 560px;
  overflow: hidden;
}
.notdo {
  width: 3750px;
  display: flex;
  overflow: hidden;
}
.seamless-warp {
  width: 99999px;
  line-height: 56px;
  height: 56px;
  overflow: hidden;
}
.notdo > div {
  margin-right: 25px;
  float: left;
  text-align: left;
  width:350px;
  font-size: 14px;
  // width: 99999px;
  cursor: pointer;
}
.notdt > div {
  margin-right: 25px;
  float: left;
  text-align: left;
  width: 28%;
}
.notboxr {
  float: right;
  margin-top: 12px;
  @media screen and (max-width: 991px) {
    max-width: 100%;
  }
}
.notbinp {
  width: 235px;
  height: 35px;
  background: #fff;
  border-radius: 35px;
  padding: 0 15px;
}
.notbinp > input {
  max-width: 190px;
  float: left;
  margin-top: 3px;
  height: 30px;
  border: 0;
  outline: none;
}
.affairs {
  background: #fff;
}
.affbox {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  @media screen and (max-width: 877px) {
    display: block;
  }
}
.affboxl {
  flex: 1;
  margin: 10px 0 10px 0;
  @media screen and (max-width: 877px) {
    margin: 0;
  }
}
.affboxl:last-child {
  @media screen and (max-width: 877px) {
    margin-bottom: 25px;
  }
}
.afftitnav {
  font-size: 18px;
  border-bottom: 1px solid #ebeaea;
  margin-left: 44px;
  text-align: left;
  height: 50px;
  line-height: 50px;
  @media screen and (max-width: 1158px) {
    margin-left: 5px;
  }
  @media screen and (max-width: 877px) {
    margin: 0 15px;
    font-size: 18px;
  }
}
.afftitnav > span {
  margin-bottom: 11px;
  padding: 0 8px 10px 8px;
  color: #1a1a1a;
}
.afftitnav > span:nth-child(2) {
  margin-left: 15px;
  // color: #525252;
}
.affsp {
  border-bottom: 2px solid #ff9900;
  color: #ff9900 !important;
}
.mt3 {
  margin-top: 20px;
}
.ggbtn {
  float: right;
  background: #ff9900;
  color: #fff;
  border: 0;
  padding: 3px 17px;
  border-radius: 5px;
  // margin-top: 5px;
  @media screen and (max-width: 800px) {
    display: none;
  }
}
.ggbtn > a {
  color: #fff;
}
.afflist {
  margin: 20px 0 0 54px;
  text-align: left;
  // @media screen and (max-width: 1158px) {
  //   margin: 20px 0 0 15px !important;
  // }
  @media screen and (max-width: 877px) {
    margin: 20px 15px 0 15px !important;
  }
}
.afflist > ul > .routerbox {
  // display: flex;
  margin-bottom: 16px;
  cursor: pointer;
}
.afflist > ul > .routerbox {
  display: flex;
  color: #000;
}
.afflist > ul > .routerbox:last-child {
  margin-bottom: 0;
}
// .afflist > ul > .routerbox:nth-child(1) >.affcont {
//   color:#ff9900
// }
// .afflist > ul > .routerbox:nth-child(2) >.affcont {
//   color:#ff9900
// }
// .afflist > ul > .routerbox:nth-child(1) > .affcont{
//     color:#ff9900
// }
// .afflist > ul > .routerbox:nth-child(2) > .affcont{
//     color:#ff9900
// }

.afftime {
  width: 65px;
  border: 1px solid #ffa41d;
  border-radius: 6px 6px 6px 6px;
  color: #ffa41d;
  text-align: center;
}
.afftime > div:first-child {
  width: 65px;
  font-size: 22px;
}
.afftime > div:last-child {
  width: 65px;
  padding: 0 5px 2px 5px;
  font-size: 12px;
  // @media screen and (max-width:800px) {
  //   font-size:13px;
  // }
}
.affcont {
  margin: 6px 0 0 7px;
  font-size: 16px;
  max-width: 455px;
  width: 100%;
  height: 45px;
  line-height: 40px;
  color: #525252;
  justify-content: center;
  @media screen and (max-width: 1125px) {
    // margin: 0;
    font-size: 14px;
    // padding-top: 5px;
  }
  @media screen and (max-width: 900px) {
    max-width: 100%;
    margin: 4px 0 0 14px;
    padding-top: 0px;
    font-size: 16px;
  }
}
.affcont:hover{
  color:#ff9900
}
.affcont >span{
    display:-webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient:vertical;
    overflow:hidden;
    text-overflow:ellipsis;
}

.wicd {
  margin:10px 0;
  background: #fffdee;
}
.wicdbox {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  text-align: left;
  @media screen and (max-width: 805px) {
    display: block;
  }
}
.winbl {
  flex: 3.5;
}

.winbr {
  flex: 6.5;
  margin-left: 32px;
  @media screen and (max-width: 850px) {
    margin-left: 0px;
  }
}
.winitit {
  color: #ff9900;
  font-size: 20px;
  padding: 25px 0;
  @media screen and (max-width: 900px) {
    font-size: 22px;
    margin-left: 10px;
  }
}
.winicont {
  margin-top: 12px;
  margin-bottom: 15px;
  @media screen and (max-width: 805px) {
    // display: none;
    text-align: center;
    margin-top: 7px;
  }
}
.winbrbtn {
  color: #ff9900;
  font-size: 14px;
  width: 88px;
  height: 38px;
  border-radius: 38px;
  border: 1px solid #ff9900;
  background: #fffdee;
  // margin: -10px 0 0 159px;
  cursor: pointer;
  @media screen and (max-width: 805px) {
    margin: -10px 0 10px 159px;
  }
}
.winbrcont {
  display: flex;
  margin-top: 87px;
  margin-bottom: 10px;
  @media screen and (max-width: 880px) {
    margin-top: 30px;
  }
  @media screen and (max-width: 805px) {
    margin-top: 30px;
  }
  @media screen and (max-width: 650px) {
    margin-top: 15px;
  }
}
.winbllist {
  flex: 1.35;
  margin-top: 30px;
  @media screen and(max-width:880px) {
    margin-top: 70px;
  }
  @media screen and(max-width:805px) {
    margin-top: 30px;
  }
}
.winbllist > ul {
  max-width: 115px;
  border-right: 2px solid #fff;
  display: flex;
  flex-flow: column;
  @media screen and(max-width:805px) {
    max-width: 150px;
  }
}
.winbllist > ul > li {
  flex: 1;
  margin: 18.5px 0;
  text-align: right;
  margin-right: 15px;
  font-size: 18px;
  cursor: pointer;
}
.winbllist > ul > li:first-child {
  margin-top: 33px;
}
.winbllist > ul > li:last-child {
  margin-bottom: 33px;
}
.cdggbtn {
  width: 100%;
  margin: 0 auto;
  display: none;
  @media screen and (max-width: 900px) {
    display: flex;
  }
}
.cdggcont {
  width: 80%;
  margin: 15px auto;
  text-align: center;
  // display: flex;
  // justify-content: space-between;
  padding: 0 15px;
  @media screen and (max-width: 500px) {
    width: 100%;
  }
}
.cdggcont > img {
  width: 90px;
  margin-left: 20px;
  @media screen and (max-width: 400px) {
    width: 75px;
  }
}
.cdggcont > img:first-child {
  margin-left: 10px;
}
.cdggbtn > ul {
  display: flex;
}
.cdggbtn > ul > li {
  width: 100%;
  text-align: center;
  padding-bottom: 15px;
}
.cdggbtn > ul > li > img {
  width: 60%;
}
.winbllcont {
  flex: 5;
  max-width: 599px;
  font-size: 14px;
  color: #7a7a7a;
  line-height: 2.2rem;
  @media screen and (max-width: 920px) {
    font-size: 16px;
    line-height: 1.7rem;
  }
  @media screen and (max-width: 805px) {
    max-width: 599px;
    font-size: 16px;
    line-height: 1.7rem;
    color: #7a7a7a;
    margin: 0 20px;
  }
}
.ent-line {
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 7;
  @media screen and (max-width: 800px) {
    -webkit-line-clamp: 4;
  }
}
.onck {
  color: #fff;
  background: linear-gradient(to left, #ff9900, #fff);
}
.actbox {
  max-width: 1200px;
  margin: 0 auto;
  text-align: left;
}
.actcont {
  display: flex;
  @media screen and (max-width: 1150px) {
    display: block;
  }
}
.actcl {
  width: 840px;
  @media screen and (max-width: 1150px) {
    width: 100%;
  }
  @media screen and (max-width: 800px) {
    display: none;
  }
}
.actimg {
  width: 320px;
  margin-left: 40px;
  @media screen and (max-width: 1100px) {
    margin-left: 15px;
    margin-right: 15px;
    width: 100%;
    // margin: 0 auto;
  }
  @media screen and (max-width: 1090px) {
    // display: none;
  }
}
.actit {
  font-size: 18px;
  color: #525252;

  @media screen and (max-width: 900px) {
    font-size: 18px;
    margin: 12px 12px 23px 25px;
  }
}
.rcjscsss {
  margin-left: 53px;
  margin-bottom: 35px;
  @media screen and (max-width: 1040px) {
    margin-left: 5px;
    margin-bottom: 0px;
  }
}
.actit > span {
  border-bottom: 2px solid #ff9900;
}
.actit1 > span {
  border-bottom: 2px solid #ff9900;
}
.actimgbox {
  margin-bottom: 10px;
}
.actimgbox > .routerbox:nth-child(2) > img{
  margin-top: 10px;
}
.actimgbox > .routerbox > img {
  width: 100%;
  height: 160px;
  // margin-top: 10px;
  cursor: pointer;
  @media screen and (max-width: 1150px) {
    display: none;
  }
  @media screen and (max-width: 500px) {
    display: block;
    height: auto;
    width: 82% !important;
    // margin-right: 20px;
    // margin:0 auto;
  }
}
.actit1 {
  font-size: 18px;
  margin: 12px 12px 23px 7px;
}
.actit1,
.diswb {
  @media screen and (max-width: 1150px) {
    display: none;
  }
  @media screen and (max-width: 500px) {
    display: block;
    // height: auto;
  }
}
.actimgbox > img:first-child {
  margin-bottom: 10px;
}
.sofcity {
  background: #f2ffee;
  @media screen and (max-width: 800px) {
    display: none;
  }
}
.sofcbox {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  text-align: left;
  padding-bottom: 10px;
  @media screen and (max-width: 837px) {
    display: block;
  }
}
.sofl {
  flex: 4;
}
.sofr {
  flex: 6;
}
.dflex {
  display: flex;
}
.soflbox {
  margin-right: 9px;
  height: 492px;
  margin-top: 15px;
}
.soflbox > div {
  flex: 1;
  margin-right: 12px;
  display: flex;
  flex-direction: column;
}
.soflbox > div:last-child {
  margin-right: 0;
}
.soflbox > div > div {
  flex: 1;
  margin-bottom: 12px;
  text-align: center;
}
.soflbox > div > div:last-child {
  margin-bottom: 0;
}
.sbox1 {
  background: #ff998f;
}
.sbox2 {
  background: #5cedd3;
}
.sbox3 {
  background: #ff7485;
}
.sbox4 {
  background: #80bfed;
}
.sbox5 {
  background: #60e0f1;
}
.sbox6 {
  background: #ffa680;
}
.sbox7 {
  background: #72e2e1;
}

.bt15 {
  // margin-left: 53px;
  margin-top: 34px;
  @media screen and (max-width: 600px) {
    margin-top: 10px;
  }
}
.sofrbox {
  border: 2px solid #60e0f1;
  margin-left: 53px;
  cursor: pointer;
  @media screen and (max-width: 1040px) {
    margin-left: 5px;
  }
}
.sofrbox > ul {
  margin: 20px ;
}
.sofrcont {
  width: 100%;
  margin-left: 17px;
  margin-right: 15px;
  border-bottom: 1px dotted #c4c4c4;
  position: relative;
  @media screen and (max-width: 837px) {
    width: 100%;
  }
}
.sofrbox > ul > .routerbox {
  margin-top: 20px;
  height: 134px;
  @media screen and (max-width: 837px) {
    height: auto;
  }
}
.sofrimg {
  // width: 128px;
  // height:134px;
  width: 100%;
  height: 100%;
  @media screen and (max-width: 950px) {
    max-width: 128px !important;
  }
  @media screen and (max-width: 837px) {
    width: 57px;
    height: 57px;
  }
}
.sofrcont > h3 {
  font-size: 16px;
  color: #222;
  margin-bottom: 7px;
  margin-top:10px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 1;
}
.sofrcont > h3:hover{
  color:#ff9900
}
.sofrcont > p {
  color: #7a7a7a;
  font-size: 14px;
}
#sofact {
  background: #60e0f1;
  color: #fff;
  position: absolute;
  bottom: 5px;
  right: 5px;
  @media screen and (max-width: 921px) {
    display: none;
  }
}
.sofrcont > button {
  background: #e7e7e7;
  border: 0;
  width: 64px;
  height: 25px;
  border-radius: 12.5pt 12.5pt 12.5pt 12.5pt;
  color: #aeadad;
  float: right;
  margin-right: 15px;
  cursor: pointer;
}
.policy {
  text-align: left;
}
.polbox {
  max-width: 1200px;
  margin: 0 auto;
}
.indcont {
  display: flex;
  margin: 0px 14px 0px 15px;
  @media screen and (max-width: 1197px) {
    display: block;
    overflow: hidden;
  }
}
.polibox1 {
  width: 30%;
  @media screen and(max-width:1197px) {
    width: 49%;
    float: left;
    margin-right: 1%;
  }
  @media screen and(max-width:774px) {
    width: 100%;
    float: left;
  }
}
.icontcol {
  flex: 1;
  border-right: 1px solid #e6e6e6;
  padding-right: 5px;
}
.indm4 {
  margin-right: 27px;
}
.indlist4 {
  // margin-right: 14px;
  font-size: 14px;
  color: #7a7a7a;
  @media screen and (max-width: 920px) {
    font-size: 16px;
  }
  @media screen and (max-width: 450px) {
    margin: 0 17px 0 30px !important;
  }
}
.indlist4 > ul {
  margin-top: 24px;
  @media screen and (max-width: 600px) {
    li:nth-child(n + 6) {
      display: none;
    }
  }
}
.indlist4 > ul > li  div {
  float: left;
  color: #b1b1b1;
  margin-right: 8px;
  font-size: 12px;
  margin-top:2px;
  // @media screen and (max-width: 600px) {
  //   display: none;
  // }
}
.gjjlist:hover{
  color:#ff9900 !important;
}
.gjjlist {
  max-width: 80%;
  color: #7a7a7a !important;
  font-size: 16px !important;
  margin-top:0px !important;
  @media screen and (max-width: 770px) {
    max-width: 88%;
  }
  @media screen and (max-width: 610px) {
    max-width: 85%;
  }
  @media screen and (max-width: 490px) {
    max-width: 78%;
  }
  @media screen and (max-width: 320px) {
    max-width: 73%;
  }
}
.polibox2 {
  width: 30%;
  margin-left: 16px;
  @media screen and (max-width: 1197px) {
    width: 48%;
    float: left;
  }
  @media screen and (max-width: 774px) {
    width: 100%;
  }
}
.indlist4 > ul > li {
  list-style-type: disc;
  margin-bottom: 14px;
  list-style: none;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  padding-left:10px;
}
.indlist4 > ul > li:before {content: '';
    display: inline-block;
    width: 4px;
    height: 4px;
    left: 0px;
    top: 10px;
    position: absolute;
    border-radius: 50%;
    background: #ffa41d;

}
.polibox3 {
  margin-left: 16px;
  width: 40%;
  @media screen and (max-width: 1197px) {
    width: 100%;
    float: left;
    margin: 0;
  }
}
.irolist1 {
  // margin: 0 15px;
  @media screen and (max-width: 800px) {
    margin: 0 30px;
  }
}
.irolbox1 {
  margin-bottom: 18px;
  border-bottom: 1px solid #cacaca;
  display: flex;
  cursor: pointer;
  @media screen and (max-width: 1200px) {
    width: 115%;
  }
}
.icolimg1 {
  margin-bottom: 16px;
}
.iconcont1 {
  font-size: 14px;
  margin-left: 10px;
  width: 75%;
  @media screen and (max-width: 1197px) {
    width: 76%;
  }
}
.polsp1 {
  font-size: 16px;
  color: #525252;
  width: 100%;
  // margin-top: 12px;
  @media screen and (max-width: 1200px) {
    width: 100%;
  }
  @media screen and (max-width: 900px) {
    width: 95%;
  }
  @media screen and (max-width: 650px) {
    width: 90%;
  }
  @media screen and (max-width: 520px) {
    width: 80%;
  }
}
.polsp1:hover{
  color:#ff9900 !important;
}
.polsp2 {
  color: #b1b1b1;
  margin-top: 5px;
}
.polsp3 {
  color: #7a7a7a;
  margin-top: 5px;
  width: 92%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 2;
}
.irolbox1:last-child {
  border-bottom: 0;
}
.services {
  background: #e2f8f1;
  padding-bottom: 20px;
  @media screen and (max-width: 1100px) {
    display: none;
  }
}
.serbox {
  max-width: 1200px;
  margin: 0 auto;
  text-align: left;
}
.serboxcont {
  display: flex;
}
.serboxcont > div {
  flex: 1;
  // margin-right: 26px;
}
.serboxctit {
  background: #fff;
}
.mmmmmmmmmt {
  padding-bottom: 0px;
  padding: 20px 15px;
}
.serboxctit > ul {
  display: flex;
  margin-left: 18px;
  color: #7a7a7a;
  padding-bottom: 20px;
  font-size: 18px;
}
.serboxctit > ul > li {
  margin-right: 10px;
}

.transf {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
// .aactive{
//   padding:10px 0;
// }
.transf > p {
  font-size: 22px;
  color: #ffffff;
}
.winicont > img {
  width: 412px;
  height: 274px;
  @media screen and(max-width:900px) {
    // width: 195px;
    // height: 163px;
    width: 60%;
    height: auto;
    margin-top: 12px;
  }
}
.minnavbox {
  background: #0086e3;
}

@media screen and (max-width: 900px) {
  .logobox {
    display: none;
  }
  .mminlogo {
    display: none;
  }
  .homeimg {
    display: none;
  }
  .headgbimg {
    display: none;
  }
  .minnav {
    display: flex;
  }

  .nav {
    display: none;
  }
  .navbul {
    display: block;
    z-index: 999;
    // position: fixed;
  }
  .notbox {
    max-width: 100%;
  }
  .notboxr {
    display: none;
  }
  .affbox {
    max-width: 900px;
    display: block;
  }
  .affboxl {
    margin: 0;
  }
  .affboxl:first-child {
    max-width:100% !important;
    height:60vw;
  }
  .afflist {
    margin: 0;
    margin-top: 5px;
  }
  .afflist > ul > .routerbox:last-child {
    margin-bottom: 16px;
  }
  .winicont {
    margin: 0;
    text-align: center;
  }
  .wicdbox {
    display: block;
  }
  .winicont > img {
    max-width: 100%;
  }
  .winbr {
    margin: 0;
  }
  .winbrcont {
    display: block;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .winbllist {
    display: none;
  }
  .winbllcont {
    max-width: 100%;
    text-indent: 2rem;
  }
  .winbrbtn {
    display: none;
  }
  .swipertwo {
    max-width: auto;
    height: auto;
  }
  .actimgbox {
    margin-bottom: 0px;
  }
  .actimgbox > img {
    display: block;
  }
  .actimgbox > img:first-child {
    margin-bottom: 0px;
  }
  .sofcbox {
    max-width: 100%;
    display: block;
  }
  .soflbox {
    height: auto;
  }
  .sofrbox {
    margin-left: 0px;
  }
  .indcont {
    display: block;
    margin: 0;
  }
  .indlist4 {
    margin: 0 15px;
  }
  .icontcol {
    border: 0;
  }
  .polibox2 {
    margin-left: 0px;
  }
  .polibox3 {
    margin-left: 0;
  }
  .swiperthree {
    max-width: 360px;
  }
  .kbd {
    display: none;
  }
  .footerbox {
    display: block;
  }
  .footerleft {
    margin: 10px 0;
  }
  .footerrig > ul {
    margin-top: 0px;
  }
  // .aactive {
  //   display: none;
  // }
  .polsp2 {
    display: none;
  }
  #sofact {
    width: 100px;
  }
}
.active {
  display: block;
}



.swiper-slide >a{
    position: relative;
    display: inline-block;
    width: 100%;
    height: 100%;
}
.swiperpt {
    position: absolute;
    bottom: 0px;
    left: 0;
    background: linear-gradient(to bottom, rgba(12,12,12,0.05), rgba(12,12,12,0.88));
    color: #f3f9ff;
    font-size: 16px;
    padding: 0 2%;
    width: 100%;
    height: 52px;
    line-height: 52px;
    text-align: left;
  }
// .el-dropdown-menu .el-dropdown-menu__item {
//   padding: 0 10px!important;
// }
.isTop {
  color: #ff9900!important;
}
// .el-popper {
//   display: none;
// }

.routerbox1 {
  color: #ff9900;
      display: inline-block;
    width: 90px;
    height: 40px;
    border: 1px solid #ff9900;
    border-radius: 20px;
    text-align: center;
}
.routerbox1:visited {
  color: #ff9900;
}
.navbul li a {
  color: #fff;
}
.el-dropdown-menu__item a,
.el-dropdown-menu__item a:visited
 {
  color: #7a7a7a;
}
.el-dropdown-menu__item:hover a {
  color: #0086e3;
}
</style>
